import { graphql } from '@predium/client-graphql';

export const UPDATE_SANDBOX_FEATURE_FLAG = graphql(`
  mutation UpdateSandboxFeatureFlag($flag: String!, $value: Boolean!) {
    updateSandboxFeatureFlag(flag: $flag, value: $value)
  }
`);

export const RESET_SANDBOX_FEATURE_FLAGS = graphql(`
  mutation ResetSandboxFeatureFlags {
    resetSandboxFeatureFlags
  }
`);
